import {
    EMPTY_BASE_INVENTORY_BY_ANTENNA_FILTERS,
    filterAntennasForInventory,
    filterRowsByNonZeroStock,
    hasActiveBaseInventoryFilters,
    matchesInventorySearch,
    type BaseInventoryByAntennaFilters,
} from '@app/inventory/inventoryByAntennaFilters';
import type {
    AntennaId,
    AntennaSummary,
    SupplyId,
    SupplyLight,
} from '@wwf/sdk';

export type SupplyInventoryFilters = BaseInventoryByAntennaFilters & {
    supplyType: string;
    notForSale: boolean;
};

export const EMPTY_SUPPLY_INVENTORY_FILTERS: SupplyInventoryFilters = {
    ...EMPTY_BASE_INVENTORY_BY_ANTENNA_FILTERS,
    supplyType: '',
    notForSale: false,
};

export function hasActiveSupplyInventoryFilters(
    filters: SupplyInventoryFilters
) {
    return (
        hasActiveBaseInventoryFilters(filters) ||
        filters.supplyType !== '' ||
        filters.notForSale
    );
}

export function filterSuppliesForInventory(
    supplies: SupplyLight[],
    filters: SupplyInventoryFilters
) {
    return supplies.filter(supply => {
        if (filters.notForSale && supply.price != null) {
            return false;
        }

        if (filters.supplyType && supply.type !== filters.supplyType) {
            return false;
        }

        return matchesInventorySearch(
            filters.rowSearch,
            supply.name,
            supply.description,
            supply.type
        );
    });
}

export function applySupplyInventoryFilters({
    supplies,
    antennas,
    filters,
    getInventoryCount,
}: {
    supplies: SupplyLight[];
    antennas: AntennaSummary[];
    filters: SupplyInventoryFilters;
    getInventoryCount: (
        supplyId: SupplyId,
        antennaId: AntennaId
    ) => number | null;
}) {
    const filteredAntennas = filterAntennasForInventory(antennas, filters);
    const filteredSupplies = filterRowsByNonZeroStock({
        rows: filterSuppliesForInventory(supplies, filters),
        antennas: filteredAntennas,
        nonZeroStockOnly: filters.nonZeroStockOnly,
        getCount: (supply, antenna) => getInventoryCount(supply.id, antenna.id),
    });

    return {
        supplies: filteredSupplies,
        antennas: filteredAntennas,
    };
}
